/**
 * Regelversion 8: Steuern je Gruppe per Gesetz (nur auf „Schwer“) und Standortpaket (alle Stufen).
 * Auf „Schwer“ lässt sich die Steuerlast nicht mehr im Haushalt verschieben, sondern nur noch mit einer
 * Steuerreform, die Bundestag und Bundesrat passieren muss.
 */
import { TPL } from '../content/issues';
import { DI } from '../content/settings';
import { STEUER8, STANDORT8, TAX_GROUPS, NEW_TAXES } from '../content/agenda8';
import { S } from './state';
import { since } from './version';
import { coopGov, canDraft, busyOf } from './coalition';
import { capOf } from './adm';

export const taxLawOn = (): boolean => since(8) && !S.mp && DI() === 2;
export const standortOn = (): boolean => since(8) && !S.mp;
const KIND: Record<string, any> = { steuer: STEUER8, standort: STANDORT8 };

/** Kann der Entwurf geöffnet werden? Grund, falls nicht. */
export function draft8Block(kind: string): string | null {
  const I = KIND[kind]; if (!I) return 'Unbekannt.';
  if (kind === 'steuer' ? !taxLawOn() : !standortOn()) return 'Nicht verfügbar.';
  if (S.phase !== 'govern') return 'Erst wenn die Regierung im Amt ist.';
  if (S.issues[I.id]?.law) return `Eine ${I.laws[0].t} ist schon im Verfahren.`;
  if (coopGov() && !canDraft('YOU', TPL(I.id, 0))) return 'Das zuständige Ressort führt euer Partner.';
  if (busyOf('YOU') >= capOf('YOU')) return 'Eure Ministerien sind gerade ausgelastet.';
  return null;
}

export function draft8(kind: string) {
  if (draft8Block(kind)) return;
  const I = KIND[kind], T = I.laws[0];
  if (!S.issues[I.id]) S.issues[I.id] = { sev: 0, prev: 0, cut: 0, law: null, on: false } as any;
  S.editing = { iss: I.id, tpl: 0, lawId: null, p: Object.fromEntries(T.ps.map((x: any) => [x.id, x.d])) } as any;
}

/** Steueränderungen je Gruppe durch beschlossene Steuerreformen (Mrd €/Jahr gegenüber dem Start). */
export function taxNow(pending = false): Record<string, number> {
  const o: Record<string, number> = {};
  for (const x of [...TAX_GROUPS, ...NEW_TAXES]) o[x.id] = 0;
  for (const L of S.laws || []) {
    if (!(L as any).fx?.tax8 || (L as any).rep) continue;
    const ok = ['kraft', 'done'].includes(L.stage) || (pending && !['failed', 'blocked', 'repealed'].includes(L.stage));
    if (!ok) continue;
    for (const k in (L as any).fx.tax) o[k] = (o[k] || 0) + (L as any).fx.tax[k];
  }
  return o;
}
